export default __webpack_public_path__ + "static/data-quote-simon-james-faa8879997338883c642922e7616c3f4.png";